// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fancybox.css
// module id = 1519
// module chunks = 173